import { buildApiUrl } from '../config/api';

// Faz download do PDF gerado pelo backend
export async function downloadTextAsPdfFromBackend(uuid) {
    const response = await fetch(buildApiUrl(`pdf/sentence/${uuid}`));
    if (!response.ok) {
        throw new Error('Erro ao gerar PDF no backend');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    // Tenta obter o nome do arquivo do header Content-Disposition
    let filename = '';
    const disposition = response.headers.get('Content-Disposition');
    if (disposition && disposition.includes('filename=')) {
        filename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
    } else {
        filename = `envelope_${uuid.split('-')[0]}.pdf`;
    }
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, 100);
}
